"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionKey_StrictMode_FE = exports.SessionKey_Permissions_FE = void 0;
const frontend_1 = require("@nu-art/user-account/frontend");
exports.SessionKey_Permissions_FE = new frontend_1.SessionKey_FE('permissions');
exports.SessionKey_StrictMode_FE = new frontend_1.SessionKey_FE('strictMode');
